export default __webpack_public_path__ + "static/media/imageTum10.84094296.jpg";